// extracted by mini-css-extract-plugin
module.exports = {"loader":"ValidationError_loader__2rHin","root":"ValidationError_root__1SXA9"};